// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { useEffect, useMemo, useRef, useState } from 'react';
import { useOpenServiceDeskLinkMutation } from '../../api/hooks';
import LinkNoLongerValid from '../../components/service-desk/LinkNoLongerValid';
import ServiceDeskStart from '../../components/service-desk/ServiceDeskStart';
import { parseLinkId } from '../../utils/ServiceDeskLinkHelper';

// Landing page for the SMS link: /service-desk?Impr-Tenant-Id=<tenant>#l=<linkId>
const ServiceDeskPage: React.FC = () => {
  const linkId = useMemo(() => parseLinkId(window.location.hash), []);
  const { openLink } = useOpenServiceDeskLinkMutation();
  const [rejected, setRejected] = useState(false);
  const openedRef = useRef(false);

  useEffect(() => {
    if (linkId && !openedRef.current) {
      openedRef.current = true;
      // Track the outcome in this component's own state: under StrictMode the mutation's observer
      // is detached after the first effect run, so its isError flag would never update.
      // A 2xx can still report an invalid link, so map that step to the same outcome as a rejection.
      openLink(linkId)
        .then((status) => {
          if (status?.step === 'LinkInvalid') {
            setRejected(true);
          }
        })
        .catch(() => setRejected(true));
    }
  }, [linkId, openLink]);

  // Every rejection looks the same to the caller so nothing reveals why a link failed.
  if (!linkId || rejected) {
    return <LinkNoLongerValid />;
  }
  return <ServiceDeskStart />;
};
export default ServiceDeskPage;
